<template>
  <div class="about">
    <h1>Registration Submitted</h1>
    <p>An email has been sent to you at {{ email }} with further instructions.</p>
  </div>
</template>
<script>
export default {
  computed: {
    email: function() {
      let userObj = this.$store.getters.getUser;
      if (userObj != null) {
        return userObj.email;
      }
      return "";
    }
  },
  mounted: function() {
    let userObj = this.$store.getters.getUser;
    if (userObj != null) {
      if (userObj.isactivated) {
        this.$router.push("/home");
      }
    }
  }
};
</script>
